'use strict'
import store from '../store'

function getToken() {
  return store.getters['mobile/mobileToken'] || ''
}

const service = process.env.VUE_APP_service_licenze || ''

const getProdottiByIds = async function (base, ids, limit, istanzaDb) {
  try {
    const data = {
      base,
      ids,
      limit,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/prodotti/list/ids`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('getProdottiByIds', err)
  }
}

const getProdotto = async function (base, id, istanzaDb) {
  try {
    const data = {
      base,
      id,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/prodotti/get`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('getProdotto', err)
  }
}

const setProdotto = async function (base, prodotto, istanzaDb) {
  try {
    const data = {
      base,
      prodotto,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/prodotti/set`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('setProdotto', err)
  }
}

const aggiornaPrezzo = async function (base, tipoPrezzo, prodottoId, chiave, valore, istanzaDb) {
  try {
    const data = {
      base,
      tipoPrezzo,
      prodottoId,
      chiave,
      valore,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/prodotti/prezzo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('aggiornaPrezzo', err)
  }
}

const getFilteredProducts = async function (base, filtri, opzioni, istanzaDb) {
  try {
    const data = {
      base,
      filtri,
      opzioni,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/prodotti/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('getFilteredProducts', err)
  }
}

const prod_list_by_filter = async function (base, filtri, opzioni, condizioni, istanzaDb) {
  try {
    const data = {
      base,
      filtri,
      opzioni,
      condizioni,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/prodotti/list`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('prod_list_by_filter', err)
  }
}

export default {
  getProdottiByIds,
  getProdotto,
  setProdotto,
  aggiornaPrezzo,
  getFilteredProducts,
  prod_list_by_filter
}